module.exports = __webpack_public_path__ + "static/media/16UNODC13.14862ca4.jpg";